var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsfdaApprovedUnitsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
    fill: "#00C950"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6359 33.1866L38.6559 44.5546C38.6785 44.6885 38.6598 44.8261 38.6021 44.949C38.5444 45.0719 38.4506 45.1742 38.3332 45.2424C38.2157 45.3105 38.0803 45.3412 37.945 45.3303C37.8097 45.3193 37.6809 45.2674 37.5759 45.1813L32.8026 41.5986C32.5721 41.4265 32.2922 41.3335 32.0046 41.3335C31.7169 41.3335 31.437 41.4265 31.2066 41.5986L26.4252 45.18C26.3203 45.2659 26.1917 45.3178 26.0566 45.3287C25.9214 45.3396 25.7861 45.3091 25.6688 45.2411C25.5515 45.1732 25.4576 45.0711 25.3998 44.9484C25.342 44.8258 25.323 44.6884 25.3452 44.5546L27.3639 33.1866",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.6667C36.4183 34.6667 40 31.085 40 26.6667C40 22.2484 36.4183 18.6667 32 18.6667C27.5817 18.6667 24 22.2484 24 26.6667C24 31.085 27.5817 34.6667 32 34.6667Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsfdaApprovedUnitsIcon);
export default __webpack_public_path__ + "static/media/USFDA Approved Units-icon.f7f41bae90a622ea8e479597bbdd285f.svg";
export { ForwardRef as ReactComponent };